/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './styles.module.scss';

const ReadIndicator = ({ read = false }) => {
  return <div className={cx(s.round, read ? s.read : s.unread)} />;
};

ReadIndicator.propTypes = {
  read: PropTypes.bool,
};

export { ReadIndicator };
